import { OrderViewMode } from '@usf/ngrx-order';

export interface ViewToggleButton {
  selected: boolean;
}

export enum ViewType {
  INSIGHTS = 'insights',
  PRICING = 'pricing',
}

export interface ViewToggleButtons {
  [OrderViewMode.insights]: ViewToggleButton;
  [OrderViewMode.pricing]: ViewToggleButton;
}
